import React, { useState } from 'react';

const AZUL = '#1F3864';

const s = {
  page: { fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 12, background: '#fff', minHeight: '100vh', color: '#24292f' },
  header: { background: AZUL, color: '#fff', padding: '4px 8px', display: 'flex', alignItems: 'center', gap: 8, position: 'sticky', top: 0, zIndex: 10 },
  headerTitle: { fontSize: 11, fontWeight: 700, lineHeight: 1.2 },
  headerSub: { fontSize: 8, opacity: 0.7 },
  body: { padding: '5px 8px' },
  section: { marginBottom: 5 },
  sectionTitle: { fontSize: 8, fontWeight: 700, letterSpacing: '0.1em', color: AZUL, borderBottom: `1px solid ${AZUL}`, paddingBottom: 1, marginBottom: 3, textTransform: 'uppercase' },
  row: { display: 'grid', gridTemplateColumns: '72px 1fr', alignItems: 'center', marginBottom: 1, gap: 3 },
  rowDouble: { display: 'grid', gridTemplateColumns: '72px 1fr 56px 1fr', alignItems: 'center', marginBottom: 1, gap: 3 },
  label: { color: '#6c757d', fontSize: 9, whiteSpace: 'nowrap' },
  labelR: { color: '#6c757d', fontSize: 9, whiteSpace: 'nowrap', textAlign: 'right' },
  inputWrap: { display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 },
  input: { border: '1px solid #d0d7de', borderRadius: 2, padding: '0 4px', fontSize: 10, background: '#f6f8fa', color: '#24292f', width: '100%', minWidth: 0, cursor: 'text', outline: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', height: 16, lineHeight: '16px', boxSizing: 'border-box' },
  copyBtn: { border: '1px solid #d0d7de', borderRadius: 2, background: '#f6f8fa', padding: '0 3px', cursor: 'pointer', height: 16, display: 'flex', alignItems: 'center', flexShrink: 0, fontSize: 10 },
};

// copyFn recibe el texto a copiar y devuelve una Promise (o nada)
// Por defecto usa navigator.clipboard del contexto actual (funciona en popup normal)
const defaultCopyFn = (text) => navigator.clipboard.writeText(String(text || ''));

function CopyBtn({ value, copyFn }) {
  const [ok, setOk] = useState(false);
  const copy = () => {
    Promise.resolve((copyFn || defaultCopyFn)(value))
      .then(() => { setOk(true); setTimeout(() => setOk(false), 1500); })
      .catch(() => {});
  };
  if (!value) return null;
  return (
    <button type="button" onClick={copy} style={{ ...s.copyBtn, color: ok ? '#198754' : '#6c757d' }} title={ok ? 'Copiado' : 'Copiar'}>
      {ok ? '✓' : '⧉'}
    </button>
  );
}

function Field({ value, copyFn }) {
  return (
    <div style={s.inputWrap}>
      <input readOnly value={value || '-'} style={s.input} title={value || ''} onClick={(e) => e.target.select()} />
      <CopyBtn value={value} copyFn={copyFn} />
    </div>
  );
}

function Row({ label, value, copyFn }) {
  return (
    <div style={s.row}>
      <span style={s.label}>{label}</span>
      <Field value={value} copyFn={copyFn} />
    </div>
  );
}

function RowDouble({ label1, value1, label2, value2, copyFn }) {
  return (
    <div style={s.rowDouble}>
      <span style={s.label}>{label1}</span>
      <Field value={value1} copyFn={copyFn} />
      <span style={s.labelR}>{label2}</span>
      <Field value={value2} copyFn={copyFn} />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={s.section}>
      <div style={s.sectionTitle}>{title}</div>
      {children}
    </div>
  );
}

// copyFn: función opcional para copiar texto. Si no se pasa, usa navigator.clipboard del contexto.
// En modo PiP se debe pasar copyFn que use la ventana PiP para evitar el error de documento sin foco.
export default function FichaInscritoContent({ data, copyFn }) {
  if (!data) return null;

  const nombre = [data.apellidos, data.nombres].filter(Boolean).join(' ');
  const tieneLibreta = data.libreta_estado && data.libreta_estado !== 'no_aplica' ? 'Si' : 'No';
  const tieneTrabajo = (data.exp_actualmente_trabaja === 1 || data.exp_actualmente_trabaja === '1' || data.exp_actualmente_trabaja === true) ? 'Si' : 'No';
  const telefono = [data.contacto_emergencia_telefono, data.contacto_emergencia_nombre].filter(Boolean).join(' - ');

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <div style={s.headerSub}>Ficha del inscrito</div>
          <div style={s.headerTitle}>{nombre || '-'}</div>
        </div>
      </div>
      <div style={s.body}>
        <Section title="Datos Generales">
          <Row label="Convocatoria" value={data.codigo_convocatoria} copyFn={copyFn} />
          <Row label="Curso" value={data.curso_nombre} copyFn={copyFn} />
          <RowDouble label1="Matrícula" value1={data.codigo_matricula} label2="Documento" value2={data.documento_identidad} copyFn={copyFn} />
          <Row label="Nombre" value={nombre} copyFn={copyFn} />
          <RowDouble label1="Tipo de sangre" value1={data.tipo_sangre} label2="Mail" value2={data.email} copyFn={copyFn} />
          <RowDouble label1="Educación" value1={data.nivel_estudio} label2="Libreta" value2={tieneLibreta} copyFn={copyFn} />
          <RowDouble label1="Teléfono" value1={telefono} label2="Celular" value2={data.telefono_celular} copyFn={copyFn} />
          <Row label="Nacionalidad" value={data.nacionalidad} copyFn={copyFn} />
        </Section>
        <Section title="Domicilio">
          <RowDouble label1="Provincia" value1={data.dom_provincia} label2="Cantón" value2={data.dom_canton} copyFn={copyFn} />
          <Row label="Dirección" value={data.dom_direccion} copyFn={copyFn} />
        </Section>
        <Section title="Trabajo">
          <Row label="Tiene trabajo" value={tieneTrabajo} copyFn={copyFn} />
          {tieneTrabajo === 'Si' && (
            <RowDouble label1="Provincia" value1={data.exp_provincia} label2="Cantón" value2={data.exp_canton} copyFn={copyFn} />
          )}
        </Section>
      </div>
    </div>
  );
}
